import { PoiAlertSpecificationOutput } from './poi-alert-specification-output.model';
import { GeoFenceAlertSpecificationOutput } from './geo-fence-alert-specification-output.model';


export class AlertSpecificationOutputData implements IAlertSpecificationOutputData {
    /** The auto-generated id of the alert specification master */
    alert_specification_id!: number;
    /** The auto-generated id of the alert master */
    alert_id!: number;
    /** The auto-generated id of the alert group master */
    alert_group_id!: number;
    /** The value common must be 2000 character max */
    value_common!: string;
    /** The text must be 2000 character max */
    text!: string;
    /** The minimum value */
    min!: number;
    /** The maximum value */
    max!: number;
    /** The abnormal halt minute */
    common_minute!: number;
    /** The POI type must be one of "All" ,"Selected" */
    poi_type!: string;
    /** The geofence type must be one of "All" ,"Selected" */
    geofence_type!: string;
    /** The sms flag should be 1 or 0 */
    sms!: number;
    /** The email flag should be 1 or 0 */
    email!: number;
    /** The mobile no must be 13 character max */
    mobile_no!: string;
    /** The email address must be 320 character max */
    email_address!: string;
    /** The auto-generated id of the country master */
    country_id!: number;
    /** AC Misuse Minute */
    ac_misuse_minute!: number;
    /** The vehicle type must be one of "On" ,"Off" or "Both" */
    common_radio_button_value!: string;
    /** Off route minute */
    off_route_minute!: number;
    /** Over speed */
    over_speed!: number;
    /** Over speed Second */
    over_speed_second!: number;
    /** Zone Over speed */
    zone_over_speed!: number;
    /** Zone over speed second */
    zone_over_speed_second!: number;
    /** The vehicle type must be one of "Single" ,"Multiple" */
    zone_over_speed_alert_generation!: string;
    /** status */
    status!: number;
    depart_from_poi_data!: PoiAlertSpecificationOutput[];
    passed_poi_data!: PoiAlertSpecificationOutput[];
    reached_poi_data!: PoiAlertSpecificationOutput[];
    enter_geofence_data!: GeoFenceAlertSpecificationOutput[];
    out_of_geofence_data!: GeoFenceAlertSpecificationOutput[];
    stay_in_zone_geofence_data!: GeoFenceAlertSpecificationOutput[];
    away_from_zone_geofence_data!: GeoFenceAlertSpecificationOutput[];
    over_speeding_geofence_data!: GeoFenceAlertSpecificationOutput[];

    constructor(data?: IAlertSpecificationOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alert_specification_id = _data["alert_specification_id"];
            this.alert_id = _data["alert_id"];
            this.alert_group_id = _data["alert_group_id"];
            this.value_common = _data["value_common"];
            this.text = _data["text"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.common_minute = _data["common_minute"];
            this.poi_type = _data["poi_type"];
            this.geofence_type = _data["geofence_type"];
            this.sms = _data["sms"];
            this.email = _data["email"];
            this.mobile_no = _data["mobile_no"];
            this.email_address = _data["email_address"];
            this.country_id = _data["country_id"];
            this.ac_misuse_minute = _data["ac_misuse_minute"];
            this.common_radio_button_value = _data["common_radio_button_value"];
            this.off_route_minute = _data["off_route_minute"];
            this.over_speed = _data["over_speed"];
            this.over_speed_second = _data["over_speed_second"];
            this.zone_over_speed = _data["zone_over_speed"];
            this.zone_over_speed_second = _data["zone_over_speed_second"];
            this.zone_over_speed_alert_generation = _data["zone_over_speed_alert_generation"];
            this.status = _data["status"];
            if (Array.isArray(_data["depart_from_poi_data"])) {
                this.depart_from_poi_data = [] as any;
                for (let item of _data["depart_from_poi_data"])
                    this.depart_from_poi_data!.push(PoiAlertSpecificationOutput.fromJS(item));
            }
            if (Array.isArray(_data["passed_poi_data"])) {
                this.passed_poi_data = [] as any;
                for (let item of _data["passed_poi_data"])
                    this.passed_poi_data!.push(PoiAlertSpecificationOutput.fromJS(item));
            }
            if (Array.isArray(_data["reached_poi_data"])) {
                this.reached_poi_data = [] as any;
                for (let item of _data["reached_poi_data"])
                    this.reached_poi_data!.push(PoiAlertSpecificationOutput.fromJS(item));
            }
            if (Array.isArray(_data["enter_geofence_data"])) {
                this.enter_geofence_data = [] as any;
                for (let item of _data["enter_geofence_data"])
                    this.enter_geofence_data!.push(GeoFenceAlertSpecificationOutput.fromJS(item));
            }
            if (Array.isArray(_data["out_of_geofence_data"])) {
                this.out_of_geofence_data = [] as any;
                for (let item of _data["out_of_geofence_data"])
                    this.out_of_geofence_data!.push(GeoFenceAlertSpecificationOutput.fromJS(item));
            }
            if (Array.isArray(_data["stay_in_zone_geofence_data"])) {
                this.stay_in_zone_geofence_data = [] as any;
                for (let item of _data["stay_in_zone_geofence_data"])
                    this.stay_in_zone_geofence_data!.push(GeoFenceAlertSpecificationOutput.fromJS(item));
            }
            if (Array.isArray(_data["away_from_zone_geofence_data"])) {
                this.away_from_zone_geofence_data = [] as any;
                for (let item of _data["away_from_zone_geofence_data"])
                    this.away_from_zone_geofence_data!.push(GeoFenceAlertSpecificationOutput.fromJS(item));
            }
            if (Array.isArray(_data["over_speeding_geofence_data"])) {
                this.over_speeding_geofence_data = [] as any;
                for (let item of _data["over_speeding_geofence_data"])
                    this.over_speeding_geofence_data!.push(GeoFenceAlertSpecificationOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertSpecificationOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSpecificationOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert_specification_id"] = this.alert_specification_id;
        data["alert_id"] = this.alert_id;
        data["alert_group_id"] = this.alert_group_id;
        data["value_common"] = this.value_common;
        data["text"] = this.text;
        data["min"] = this.min;
        data["max"] = this.max;
        data["common_minute"] = this.common_minute;
        data["poi_type"] = this.poi_type;
        data["geofence_type"] = this.geofence_type;
        data["sms"] = this.sms;
        data["email"] = this.email;
        data["mobile_no"] = this.mobile_no;
        data["email_address"] = this.email_address;
        data["country_id"] = this.country_id;
        data["ac_misuse_minute"] = this.ac_misuse_minute;
        data["common_radio_button_value"] = this.common_radio_button_value;
        data["off_route_minute"] = this.off_route_minute;
        data["over_speed"] = this.over_speed;
        data["over_speed_second"] = this.over_speed_second;
        data["zone_over_speed"] = this.zone_over_speed;
        data["zone_over_speed_second"] = this.zone_over_speed_second;
        data["zone_over_speed_alert_generation"] = this.zone_over_speed_alert_generation;
        data["status"] = this.status;
        if (Array.isArray(this.depart_from_poi_data)) {
            data["depart_from_poi_data"] = [];
            for (let item of this.depart_from_poi_data)
                data["depart_from_poi_data"].push(item.toJSON());
        }
        if (Array.isArray(this.passed_poi_data)) {
            data["passed_poi_data"] = [];
            for (let item of this.passed_poi_data)
                data["passed_poi_data"].push(item.toJSON());
        }
        if (Array.isArray(this.reached_poi_data)) {
            data["reached_poi_data"] = [];
            for (let item of this.reached_poi_data)
                data["reached_poi_data"].push(item.toJSON());
        }
        if (Array.isArray(this.enter_geofence_data)) {
            data["enter_geofence_data"] = [];
            for (let item of this.enter_geofence_data)
                data["enter_geofence_data"].push(item.toJSON());
        }
        if (Array.isArray(this.out_of_geofence_data)) {
            data["out_of_geofence_data"] = [];
            for (let item of this.out_of_geofence_data)
                data["out_of_geofence_data"].push(item.toJSON());
        }
        if (Array.isArray(this.stay_in_zone_geofence_data)) {
            data["stay_in_zone_geofence_data"] = [];
            for (let item of this.stay_in_zone_geofence_data)
                data["stay_in_zone_geofence_data"].push(item.toJSON());
        }
        if (Array.isArray(this.away_from_zone_geofence_data)) {
            data["away_from_zone_geofence_data"] = [];
            for (let item of this.away_from_zone_geofence_data)
                data["away_from_zone_geofence_data"].push(item.toJSON());
        }
        if (Array.isArray(this.over_speeding_geofence_data)) {
            data["over_speeding_geofence_data"] = [];
            for (let item of this.over_speeding_geofence_data)
                data["over_speeding_geofence_data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAlertSpecificationOutputData {
    /** The auto-generated id of the alert specification master */
    alert_specification_id: number;
    /** The auto-generated id of the alert master */
    alert_id: number;
    /** The auto-generated id of the alert group master */
    alert_group_id: number;
    /** The value common must be 2000 character max */
    value_common: string;
    /** The text must be 2000 character max */
    text: string;
    /** The minimum value */
    min: number;
    /** The maximum value */
    max: number;
    /** The abnormal halt minute */
    common_minute: number;
    /** The POI type must be one of "All" ,"Selected" */
    poi_type: string;
    /** The geofence type must be one of "All" ,"Selected" */
    geofence_type: string;
    /** The sms flag should be 1 or 0 */
    sms: number;
    /** The email flag should be 1 or 0 */
    email: number;
    /** The mobile no must be 13 character max */
    mobile_no: string;
    /** The email address must be 320 character max */
    email_address: string;
    /** The auto-generated id of the country master */
    country_id: number;
    /** AC Misuse Minute */
    ac_misuse_minute: number;
    /** The vehicle type must be one of "On" ,"Off" or "Both" */
    common_radio_button_value: string;
    /** Off route minute */
    off_route_minute: number;
    /** Over speed */
    over_speed: number;
    /** Over speed Second */
    over_speed_second: number;
    /** Zone Over speed */
    zone_over_speed: number;
    /** Zone over speed second */
    zone_over_speed_second: number;
    /** The vehicle type must be one of "Single" ,"Multiple" */
    zone_over_speed_alert_generation: string;
    /** status */
    status: number;
    depart_from_poi_data: PoiAlertSpecificationOutput[];
    passed_poi_data: PoiAlertSpecificationOutput[];
    reached_poi_data: PoiAlertSpecificationOutput[];
    enter_geofence_data: GeoFenceAlertSpecificationOutput[];
    out_of_geofence_data: GeoFenceAlertSpecificationOutput[];
    stay_in_zone_geofence_data: GeoFenceAlertSpecificationOutput[];
    away_from_zone_geofence_data: GeoFenceAlertSpecificationOutput[];
    over_speeding_geofence_data: GeoFenceAlertSpecificationOutput[];
}

